import moment from "moment";
import React from "react";

import { version } from "../../constants";

export const Footer = () => {
  const isNonProdEnvironment = window.location.host.split(".")[0] !== "fastdraw";
  const showDebugInfo = isNonProdEnvironment;

  return (
    <div className="bottom-footer-content helvetica-neue-medium">
      <footer>
        <p>Copyright © {moment().year()} FastModel Sports®. All Rights Reserved.</p>
        <p>
          FastDraw - {version} {showDebugInfo ? `- ${process.env.REACT_APP_GIT_SHA}` : ""}
        </p>
      </footer>
    </div>
  );
};
